import { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiTabs: Components<CssVarsTheme>['MuiTabs'] = {
  defaultProps: {
    variant: 'scrollable',
    allowScrollButtonsMobile: true
  },
  styleOverrides: {
    indicator: ({ theme }) => ({
      backgroundColor: theme.vars.palette.primary.dark,
      [theme.breakpoints.down('md')]: {
        display: 'none'
      }
    }),
    flexContainer: ({ theme }) => ({
      gap: theme.spacing(3)
    })
  }
};

export const MuiTab: Components<CssVarsTheme>['MuiTab'] = {
  defaultProps: {
    disableRipple: true,
    iconPosition: 'top'
  },
  styleOverrides: {
    root: ({ theme }) => ({
      textTransform: 'none',
      fontWeight: 500,
      padding: 0,
      minWidth: 0,
      '&.Mui-selected': {
        color: theme.vars.palette.primary.dark
      }
    })
  }
};
